import { createStyles, makeStyles, Theme, Typography } from "@material-ui/core";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    progress: {
      //position: relative;
      background: "#a4cade",
      borderRadius: 8.5,
      height: 17,
      //width: 100 %,
      overflow: "hidden",
      margin: 10,
      marginBottom: 25,
    },
    progressInner: {
      height: "100%",
      //position: 'absolute',
      //top: 0,
      //left: 0,
      background: theme.palette.text.primary,
      //-webkit-transition: width .3s;
      //-o-transition: width .3s;
      transition: "width, .3s",
      //display: -webkit-box;
      //display: -ms-flexbox;

      display: "flex",
      //-webkit-box-align: center;
      //-ms-flex-align: center;
      //align-items: center;
      //-webkit-box-pack: center;
      //-ms-flex-pack: center;
      justifyContent: "center",
    },

    progressText: {
      color: "white",
      fontWeight: "bold",
      //theme.typography.fontWeightBold, fuest
    },
  })
);

type ProgressbarParam = {
  prozent: number;
};

const Progressbar: React.FC<ProgressbarParam> = ({ prozent }) => {
  const classes = useStyles();

  return (
    <div className={classes.progress}>
      <div className={classes.progressInner} style={{ width: `${prozent}%` }}>
        <Typography
          variant="body2"
          color="textSecondary"
          className={classes.progressText}
        >{`${prozent}%`}</Typography>
      </div>
    </div>
  );
};

export default Progressbar;
